import ServiceBase from '@ekd/portal-connector/dist/Service';
import { ApiUrls } from '@root/common/types/apiUrls';
import { getEnv } from '@root/common/utils/getEnv';

import { Subscription } from '@paywall/types';

/**
 * @returns user subscription packages
 */
export function createGetSubscriptionService({ service }: { service: ServiceBase<ApiUrls> }) {
  return {
    async getSubscription(token?: string | null) {
      if (!token) {
        return null;
      }

      const jwtParse = JSON.parse(atob(token.split('.')[1]));
      const id = jwtParse.cid;

      try {
        const apiProvider = service.createProvider('HTTP');
        const headers = { Authorization: `Bearer ${token}` };
        const response = await apiProvider.request<Subscription[]>({ url: `${getEnv('ordersApi')}/user/${id}/service-info`, headers, method: 'get' });

        const data: Subscription[] = [];
        if (response.length) {
          response.forEach((subscription) => {
            if (subscription.valid) {
              data.push(subscription);
            }
          });
        }

        return data;
      } catch (error) {
        return [];
      }
    },
  };
}
